module.exports = __webpack_public_path__ + "img/providus.9559db98.png";